var ACTIONS;
(function (ACTIONS) {
    ACTIONS["SHOW"] = "paymentMeanDetailsModal/SHOW";
    ACTIONS["HIDE"] = "paymentMeanDetailsModal/HIDE";
    ACTIONS["KLARNA"] = "paymentMeanDetailModal/KLARNA";
    ACTIONS["FLOA"] = "paymentMeanDetailModal/FLOA";
    ACTIONS["START_LOADING_FLOA"] = "paymentMeanDetailModal/START_LOADING_FLOA";
    ACTIONS["START_LOADING_KLARNA"] = "paymentMeanDetailModal/START_LOADING_KLARNA";
    ACTIONS["HANDLE_ERROR"] = "paymentMeanDetailModal/ERROR";
})(ACTIONS || (ACTIONS = {}));
export default ACTIONS;
